export default __webpack_public_path__ + "media/images/icon_home-b975852cd284efcef781def5d944de24.png";